// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tax-statement{margin-top:.5rem}", "",{"version":3,"sources":["webpack://./src/components/labels/tax-statement/tax-statement.scss"],"names":[],"mappings":"AAEA,eACI,gBAAA","sourcesContent":["@import '@ee-theme/ee-utils';\n\n.tax-statement {\n    margin-top: pxToRem(8px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
